import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { buildNavGroups } from '../../layout/nav-config';
import { RESTRICTED_LANDING } from './access-restricted.guard';
import { withUserContext } from './with-user-context';

/**
 * The shell's default route (`/`): sends the user to the first page in their side nav
 * — Employee Monitoring, else Prehire Review. A restricted Authorized User always lands
 * on their Session Audit Log (even when Reports is in their nav). Never activates itself. Waits for the user
 * context; with none it fails closed to /unauthorized (SECURITY-08).
 */
export const landingGuard: CanActivateFn = () => {
  const router = inject(Router);
  return withUserContext((context) => {
    if (context.accessRestricted) {
      return router.createUrlTree([RESTRICTED_LANDING]);
    }
    const groups = buildNavGroups(
      context.role,
      context.assignedDataTypes,
      context.locationManagementEnabled,
    );
    return router.createUrlTree([groups[0]?.items[0]?.route ?? RESTRICTED_LANDING]);
  });
};
